import { Modal, Spin, Pagination } from "antd";
import React, { useEffect, useState } from "react";
import { FaMedkit } from "react-icons/fa";
import LabOrderService from "../../../Services/LabOrderService";
import Lab from "../../../Assets/Icons/Lab.svg";

function ViewReports({ appointmentDetails }) {
  const [openModal, setOpenModal] = useState(false);
  const [labReports, setLabReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewDoc, setViewDoc] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  // pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 8; // 4 per row × 2 rows

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const patientLabReports = async () => {
    let payload = {
      userId: appointmentDetails.userId,
      patientId: appointmentDetails.patientId,
      status: 1,
    };

    try {
      setLoading(true);
      const response = await LabOrderService.getLabReportsData(payload);
      setLabReports(response?.data || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (openModal) {
      patientLabReports();
    }
  }, [openModal]);

  const showModal = () => {
    setOpenModal(true);
  };

  // pagination logic
  const startIndex = (currentPage - 1) * pageSize;
  const currentData = labReports.slice(startIndex, startIndex + pageSize);

  const handleViewDocument = (item) => {
    setSelectedDoc({
      title: item.labTestName,
      documentName: item.resultDocumentName,
    });
    setViewDoc(true);
  };

  return (
    <>
      <button
        onClick={showModal}
        title="Lab Reports"
        className="p-2 text-sm bg-white border text-white rounded-md hover:bg-blue-600 transition w-8 h-8"
      >
        <img src={Lab} alt="" className="" />
      </button>

      <Modal
        title="Lab Reports"
        open={openModal}
        destroyOnClose
        onCancel={handleCloseModal}
        footer={null}
        width={1100} // 🔥 big modal
      >
        {/* 🔄 Loader */}
        {loading ? (
          <div className="flex justify-center items-center h-60">
            <Spin size="large" />
          </div>
        ) : labReports.length === 0 ? (
          <div className="text-center py-10 text-gray-500">
            No Reports Found
          </div>
        ) : (
          <>
            {/* 🧾 Cards Grid */}
            <div className="grid grid-cols-4 gap-4">
              {currentData.map((item, index) => (
                <div
                  key={index}
                  className="border rounded-xl p-4 shadow-sm hover:shadow-md transition bg-white"
                >
                  <h3 className="font-semibold text-sm mb-2 line-clamp-2">
                    {item.labTestName}
                  </h3>

                  <p className="text-xs text-gray-500 mb-1">
                    🏥 {item.vendorName}
                  </p>

                  <p className="text-xs text-gray-400 mb-3">
                    📅 {item.uploadedDateTime}
                  </p>

                  <button
                    className="w-full text-xs bg-blue-500 text-white py-1 rounded hover:bg-blue-600"
                    onClick={() => handleViewDocument(item)}
                  >
                    View Report
                  </button>
                </div>
              ))}
            </div>

            {/* 📄 Pagination */}
            <div className="flex justify-center mt-6">
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={labReports.length}
                onChange={(page) => setCurrentPage(page)}
              />
            </div>
          </>
        )}
      </Modal>

      {viewDoc && (
        <Modal
          title={selectedDoc?.title}
          open={viewDoc}
          onCancel={() => {
            setViewDoc(false);
            setSelectedDoc(null);
          }}
          footer={null}
          width={1200}
        >
          {selectedDoc?.documentName && (
            <>
              {selectedDoc.documentName.match(/\.(jpg|jpeg|png)$/i) ? (
                <div className="flex justify-center">
                  <img
                    src={`${process.env.REACT_APP_IMAGE_URL}${selectedDoc.documentName}#zoom=page-width`}
                    alt="report"
                    className="max-h-[500px] object-contain"
                  />
                </div>
              ) : (
                <iframe
                  src={`${process.env.REACT_APP_IMAGE_URL}${selectedDoc.documentName}`}
                  title="report"
                  style={{ width: "100%", height: "500px" }}
                />
              )}
            </>
          )}
        </Modal>
      )}
    </>
  );
}

export default ViewReports;
